import { useState } from "react";

const PILLARS = [
  { letter: "E", name: "Education", key: "education", color: "#D98A18", body: "Computer literacy, teacher training, scholarships, and academic competitions — from MDGCLP and SGTATS to MAWASCF and the new CICMS school." },
  { letter: "R", name: "Research", key: "research", color: "#31517E", body: "Community-driven studies through the C. Mercy Frank Research and Innovation Initiative (CMFRII), turning local knowledge into better programs." },
  { letter: "S", name: "Social Engagement", key: "social", color: "#C05A3A", body: "Media, storytelling, and civic life — from HOFAVIPROC's documentary work and HOFA MUSIC to community events that bring Mango Town together." },
  { letter: "E", name: "Economic Empowerment", key: "economic", color: "#1F5C38", body: "JMTEEI skills and enterprise support, ESAFC football development, and pathways to sustainable livelihoods for youth and families." },
  { letter: "H", name: "Health Services", key: "health", color: "#A62639", body: "COHEDIP health education and development intervention — awareness campaigns, malaria and Ebola education, and school-based prevention." },
];

export default function PillarStrip() {
  const [openKey, setOpenKey] = useState(null);
  return (
    <div className="flex flex-col md:flex-row gap-3 min-h-[110px] md:min-h-[380px]">
      {PILLARS.map((p) => {
        const isOpen = openKey === p.key;
        return (
          <button
            type="button"
            key={p.key}
            data-testid={`pillar-strip-${p.key}`}
            onClick={() => setOpenKey(isOpen ? null : p.key)}
            onFocus={() => setOpenKey(p.key)}
            className={`group relative overflow-hidden rounded-2xl text-left px-5 py-6 md:px-5 md:py-6 flex flex-col justify-end transition-[flex] duration-500 ease-out cloth-stripes ${isOpen ? "flex-[2.6]" : "flex-1"}`}
            style={{ background: p.color }}
          >
            <span className="relative z-10 font-display text-5xl md:text-6xl font-bold text-white/95 leading-none">{p.letter}</span>
            <h3 className="relative z-10 mt-2 mb-2 text-white text-xl font-display">{p.name}</h3>
            <p
              className={`relative z-10 text-sm text-white/90 max-w-[34ch] transition-all duration-500 ${isOpen ? "opacity-100 max-h-52 mt-1" : "opacity-0 max-h-0"}`}
            >
              {p.body}
            </p>
          </button>
        );
      })}
    </div>
  );
}
